import { render, staticRenderFns } from "./CreditsDialog.vue?vue&type=template&id=86414188&scoped=true"
import script from "./CreditsDialog.vue?vue&type=script&lang=js"
export * from "./CreditsDialog.vue?vue&type=script&lang=js"
import style0 from "./CreditsDialog.vue?vue&type=style&index=0&id=86414188&prod&lang=scss&scoped=true"
import style1 from "./CreditsDialog.vue?vue&type=style&index=1&id=86414188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86414188",
  null
  
)

export default component.exports